import { CalendarPrimeReact, DropdownPrimeReact } from "@finanedi.es/storybook"
import { useCuentasBancariasAll } from "api/CuentaBancaria.hook"
import CustomButton from "common/components/Button/Button"
import DropdownContactos from "common/components/ContactsDropdown/ContactsDropdown"
import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import { SEARCH_PARAMS } from "common/constants"
import { getSearchParams } from "common/utils/utils"
import SwitchBtns from "features/Crear/components/SwitchBtns"
import useContactoSelector from "features/Tesoreria/hooks/useContactoSelector"
import { ErrorMessage } from "formik"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { backendDateFormat } from "utils/formatDate"
import { getCuentaFromCuentasBancarias } from "../NewRemesaForm/constants"
import { CURRENT_PAYMENT_TYPE, dontEditPagoCobroRelacion } from "./constants"
import "./styles.scss"

const PagoForm = ({
  hideModal,
  handleChange,
  setFieldValue,
  values,
  handleSubmit,
  errors,
  touched,
  resetForm,
  handleBlur,
  isEditView,
  handleDelete,
  data,
  hasSwitch,
}: $TSMigrationFixMe) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const location = useLocation()
  const [selectedAccount, setSelectedAccount] = useState()
  const { cuentaBancariaAll } = useCuentasBancariasAll({})
  const blockEdit = Boolean(data?.tipoRemesable === dontEditPagoCobroRelacion)
  const isDisabled =
    Boolean(values?.facturaId) ||
    Boolean(data?.remesaId) ||
    Boolean(data?.comeFromFactura) ||
    blockEdit

  const {
    contactoSelected,
    handleSetIsComprador,
    placeholder,
    titlePagosCobros,
    transactionTypeValue,
  } = useContactoSelector(values.empresaId)

  useEffect(() => {
    if (values?.cuentaBancariaId && cuentaBancariaAll?.items) {
      getCuentaFromCuentasBancarias(
        cuentaBancariaAll.items,
        values.cuentaBancariaId
      ).then((res) => {
        return setSelectedAccount(res.id)
      })
    }
    return () => {
      resetForm()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditView, cuentaBancariaAll?.items])

  const onSubmit = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    setFieldValue("valueKey", transactionTypeValue)
    // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type 'nev...
    if (contactoSelected?.razonSocial) {
      // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type 'nev...
      setFieldValue("razonSocial", contactoSelected?.razonSocial)
      // @ts-expect-error TS(2339): Property 'empresaContactoId' does not exist on typ...
      setFieldValue("empresaId", contactoSelected.empresaContactoId)
    } else {
      setFieldValue("razonSocial", values?.razonSocial)
      setFieldValue("empresaId", values?.empresaId)
    }

    handleSubmit({ ...values, titlePagosCobros })
  }

  const handleDate = (e: $TSMigrationFixMe) => {
    setFieldValue("fecha", backendDateFormat(e.target.value))
  }

  const handleBankAccount = ({ value }: $TSMigrationFixMe) => {
    setFieldValue("cuentaBancariaId", value)
    setSelectedAccount(value)
  }

  const handleToogle = (IsActive: $TSMigrationFixMe) => {
    handleSetIsComprador(IsActive)
    setFieldValue("tipo", CURRENT_PAYMENT_TYPE[IsActive ? "COBRO" : "PAGO"])
    setFieldValue("empresaId", values?.empresaId)
  }
  useEffect(() => {
    if (values?.tipo) {
      handleSetIsComprador(
        values?.tipo ? values?.tipo === CURRENT_PAYMENT_TYPE.PAGO : true
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.tipo])

  const openCreateDialogByDefault = () => {
    const param = getSearchParams(location, SEARCH_PARAMS.GOTO)
    const isCreateCobro = param === SEARCH_PARAMS.COBRO
    const isCreatePago = param === SEARCH_PARAMS.PAGO
    const isCreateDirectAccess = isCreateCobro || isCreatePago

    if (isCreateDirectAccess) handleToogle(isCreateCobro)
  }

  useEffect(() => {
    openCreateDialogByDefault()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <form onSubmit={onSubmit}>
      <div className='mb-3 p-fluid'>
        {hasSwitch && !isEditView && (
          <div className='p-field'>
            <p className='text__simple'>{t("pagoCobro.modal.labelTypeMov")}</p>
            <SwitchBtns
              labelRight={t("pagoCobro.modal.labelCollection")}
              labelLeft={t("pagoCobro.modal.labelPayment")}
              onClickRight={() => handleToogle(true)}
              onClickLeft={() => handleToogle(false)}
              leftActive={values?.tipo === CURRENT_PAYMENT_TYPE.PAGO}
            />
          </div>
        )}

        <label htmlFor='empresaId'>
          {t("pagoCobro.modal.labelCompanyName")}
        </label>
        <DropdownContactos
          id='empresaId'
          name='empresaId'
          className={`tw-w-full tw-rounded tw-h-10 [&>:nth-child(3)]:!tw-font-roboto ${
            errors.empresaId && touched.empresaId
              ? "!tw-border-danger"
              : "!tw-border-neutral-25"
          } ${isDisabled ? "!tw-bg-neutral-10" : ""}`}
          value={values?.empresaId}
          onchange={({ value }: { value: string }) =>
            setFieldValue("empresaId", value)
          }
          {...(values?.razonSocial && {
            pushDefaultOption: {
              empresaContactoId: values?.empresaId,
              razonSocial: values?.razonSocial,
            },
          })}
          placeholder={placeholder}
          panelClassName='!tw-z-[2302]'
          disabled={isDisabled}
        />
        <ErrorMessage
          name='empresaId'
          className='tw-text-danger tw-text-left tw-text-xs'
          component='div'
        />
      </div>

      <div className='mb-3 select-main_content'>
        <div className='select_container w-100'>
          <label htmlFor='tipoDocumento'>
            {t("pagoCobro.modal.labelImport")}
          </label>
          <FormikInputNumber
            id='importe'
            name='importe'
            onBlur={handleBlur}
            disabled={data?.remesaId || blockEdit}
            minFractionDigits={2}
            maxFractionDigits={2}
            readOnly={blockEdit}
          />
        </div>
        <div className='text-left col-md-12 col-lg-5 select_container'>
          <label htmlFor='tipoDocumento'>
            {t("pagoCobro.modal.labelDate")}
          </label>
          <CalendarPrimeReact
            id='fecha'
            name='fecha'
            clearButtonClassName='!tw-hidden'
            value={values?.fecha ? new Date(values?.fecha) : undefined}
            locale={language}
            onChange={handleDate}
            placeholder='dd/mm/aaaa'
            dateFormat='dd/mm/yy'
            className={`w-full ${
              errors?.fecha && touched.fecha
                ? "[&>input]:!tw-border-danger"
                : "[&>input]:!tw-border-neutral-25"
            }`}
            showIcon
            onBlur={handleBlur}
            disabled={data?.remesaId || blockEdit}
            baseZIndex={2302}
          />
          <ErrorMessage
            name='fecha'
            className='tw-text-danger tw-text-left tw-text-xs'
            component='div'
          />
        </div>
      </div>
      <div className='mb-3 select_container'>
        <label htmlFor='tipoDocumento'>
          {t("pagoCobro.modal.labelAccount")}
        </label>
        <DropdownPrimeReact
          options={cuentaBancariaAll?.items ?? []}
          value={selectedAccount}
          optionValue='id'
          optionLabel='iban'
          onChange={(value) => handleBankAccount(value)}
          // @ts-expect-error TS(2769): No overload matches this call.
          placeholder={t("pagoCobro.modal.placeholderSelectAccount")}
          emptyFilterMessage={t("pagoCobro.modal.placeholderNoResult")}
          emptyMessage={t("pagoCobro.modal.placeholderNoResult")}
          fluid
          onBlur={handleBlur}
          disabled={data?.remesaId}
          panelClassName='!tw-z-[2302]'
          className={data?.remesaId ? "!tw-bg-neutral-10" : ""}
        />
      </div>

      <div className='select_container '>
        <label htmlFor='tipoDocumento'>
          {t("pagoCobro.modal.labelDescip")}
        </label>
        <FormikInputText
          id='descripcion'
          name='descripcion'
          onChange={handleChange}
          type='text'
          value={values.descripcion ? "" : values.descripcion}
          onBlur={handleBlur}
        />
      </div>
      <div
        className={`d-flex ${
          isEditView ? "justify-content-between" : "justify-content-end"
        } align-items-center`}
      >
        {isEditView && (
          <div className='delete-action'>
            <p onClick={() => handleDelete(data?.id, data?.tipo)}>
              {t("pagoCobro.modal.deleteButton")}
            </p>
          </div>
        )}
        <div className='departaments-modal__actions'>
          <p onClick={() => hideModal()}>{t("pagoCobro.modal.cancelButton")}</p>
          <CustomButton
            type='submit'
            className='tw-ml-2 !tw-bg-primary tw-cursor-pointer'
          >
            {isEditView
              ? `${t("pagoCobro.modal.editButton")}`
              : `${t("pagoCobro.modal.createButton")}`}
          </CustomButton>
        </div>
      </div>
    </form>
  )
}

export default PagoForm
